exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sm_bloc[data-v-3a854cea]{background:#f5f5f5;margin:20px;border-radius:30px;padding:15px;box-shadow:0 3px 6px rgba(0,0,0,.1607843137254902);width:70%}.sm_bloc .data[data-v-3a854cea]{color:#9561e2;font-weight:700;font-size:23px;margin-bottom:5px}.sm_bloc .title[data-v-3a854cea]{color:#707070;font-size:20px}.sm_bloc .modalIcon[data-v-3a854cea]{position:absolute;top:22%;right:20%}", ""]);

// exports
